import { alert } from '@/store/iframe/types';
/**
 * Wrapper State
 */
export class State {
  public overlay: boolean;
  public alert: any;

  constructor() {
    this.overlay = false;
    this.alert = alert;
  }
}

const state = new State();

export default state;
